import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PIPOff = function PIPOff(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.3699 12.9393C17.737 12.9563 18.0156 12.6721 17.9921 12.3046C17.9686 11.937 17.6519 11.6254 17.2847 11.6085L14.167 11.4647L17.8524 7.77926C18.0979 7.53381 18.0747 7.11268 17.8007 6.83862C17.5266 6.56457 17.1055 6.54138 16.86 6.78683L13.051 10.5959L13.0313 7.38084C13.029 7.01493 12.729 6.68736 12.3611 6.6492C11.9932 6.61104 11.6968 6.87674 11.699 7.24265L11.7323 12.6794L17.3699 12.9393Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 2C7.67157 2 7 2.67157 7 3.5V7H4.15239C3.51513 7 3 7.5166 3 8.15385V20.8462C3 21.4834 3.5166 22 4.15385 22H16.8462C17.4834 22 18 21.4834 18 20.8462V18.1538C18 18.1017 17.9965 18.0503 17.9898 18L21.5 18C22.3284 18 23 17.3284 23 16.5V3.5C23 2.67157 22.3284 2 21.5 2H8.5ZM9 16V4H21V16H9Z",
      fill: color
    })]
  });
};
export default PIPOff;